export enum SearchField {
    Email = "Email",
    Subject = "Subject",
    Issuer = "Issuer"
}
